import React, { useEffect, useState } from 'react'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import Button from "@material-ui/core/Button"
import { FormControl } from '@material-ui/core'
import Container from '@material-ui/core/Container'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import DataTable from 'react-data-table-component'
import Input from '@material-ui/core/Input'
import { useHistory } from 'react-router-dom'
import GetAppIcon from '@material-ui/icons/GetApp'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import Divider from "@material-ui/core/Divider"
import { TelematicsStyles } from '../TelematicsStyles'
import { useTranslation } from 'react-i18next'
import { connect } from "react-redux"
import { bindActionCreators } from 'redux'
import * as navigationActions from '../../../actions/common/NavigationActions'
import * as TelematicsActions from '../../../actions/telematics/TelematicsActions'
import { customStyleSecondary } from '../../common/CommonStyles'
import Modal from 'antd/es/modal'
import UseForm from '../../common/UseForm'
import { Backdrop, CircularProgress } from '@material-ui/core'

const ViaticInvoice = ({ classes, ...props }) => {
    const { t } = useTranslation();
    const history = useHistory()
    const { match: { params } } = props
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState(false)

    const paginationOptions = { rowsPerPageText: t('commonMessages.rowsPerPage'), rangeSeparatorText: t('common.to'), selectAllRowsItem: true, selectAllRowsItemText: t('common.all') }

    const initialFieldValues = {
        orderNumber: parseInt(params.instalationId),
        pdf: {},
        xml: {},
        excel: {}
    }

    const {
        values,
        handleInpuFileChange
    } = UseForm(initialFieldValues)

    useEffect(() => {
        handleOpenBackdrop()
        let isViatic = true
        props.actions.fetch_Viatic_Documents(props.userLanguage, props.userToken, params.instalationId, isViatic, onError, onSuccess)
        return () => {

        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (Object.keys(values.xml).length !== 0 && Object.keys(values.pdf).length !== 0 && Object.keys(values.excel).length !== 0) {
            setUploadedFiles(true)
        } else {
            setUploadedFiles(false)
        }
    }, [values]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }

    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }

    const onSuccess = () => {
        handleCloseBackdrop()
    }

    const onSuccessSave = (response) => {
        handleCloseBackdrop()
        if (response.status) {
            Modal.success({
                title: t('commonMessages.savedSucc')
            })
            Array.from(document.querySelectorAll("input")).forEach(
                input => (input.value = "")
            )
            let isViatic = true
            props.actions.fetch_Viatic_Documents(props.userLanguage, props.userToken, params.instalationId, isViatic, onError, onSuccess)
        } else {
            if (response.message === null) {
                Modal.error({
                    title: 'Error',
                    content: t('commonMessages.alertInvoiceInvalid')
                })
            } else {
                Modal.error({
                    title: 'Error',
                    content: t(`telematicsErrors.${response.message}`)
                })
            }
        }
    }

    const onSuccessDelete = (response) => {
        handleCloseBackdrop()
        let isViatic = true
        props.actions.fetch_Viatic_Documents(props.userLanguage, props.userToken, params.instalationId, isViatic, onError, onSuccess)
        Modal.success({
            title: t('commonMessages.deletedSucc')
        })
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 400:
                    Modal.error({
                        title: 'Error',
                        content: t(`telematicsErrors.${err.response.data.errors.ErrorCodes[0]}`)
                    })
                    break
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    Modal.error({
                        title: 'Error',
                        content: <Typography variant="body1" style={{ fontWeight: 600 }}>{t('commonMessages.alert500')}</Typography>
                    })
                    break
                default:
                    break
            }
        }
    }

    const checkFileTypePDF = event => {
        let file = event.target.files[0]
        if (file != null) {
            let types = ['application/pdf']

            if (types.every(type => file.type !== type)) {
                Modal.error({
                    title: 'Error',
                    content: t('commonMessages.unsupportedFormat')
                })
                event.target.value = null
                return false
            } else {
                handleInpuFileChange(event)
            }
        }
    }

    const checkFileTypeXML = event => {
        let file = event.target.files[0]
        if (file != null) {
            let types = ['text/xml', 'application/xml']

            if (types.every(type => file.type !== type)) {
                Modal.error({
                    title: 'Error',
                    content: t('commonMessages.unsupportedFormat')
                })
                event.target.value = null
                return false
            } else {
                handleInpuFileChange(event)
            }
        }
    }

    const checkFileTypeXLS = event => {
        let file = event.target.files[0]
        if (file != null) {
            let types = ['text/csv', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']

            if (types.every(type => file.type !== type)) {
                Modal.error({
                    title: 'Error',
                    content: t('commonMessages.unsupportedFormat')
                })
                event.target.value = null
                return false
            } else {
                handleInpuFileChange(event)
            }
        }
    }

    const handleSubmit = e => {
        if (uploadedFiles) {
            e.preventDefault()
            handleOpenBackdrop()

            const formData = new FormData()
            formData.append('orderNumber', values.orderNumber)

            for (let file of values.pdf) {
                formData.append("pdf", file);
            }
            for (let file of values.xml) {
                formData.append("xml", file);
            }
            for (let file of values.excel) {
                formData.append("excel", file);
            }

            props.actions.update_Invoice_Order(props.userLanguage, props.userToken, formData, onError, onSuccessSave)
        } else {
            Modal.error({
                title: 'Error',
                content: t('commonMessages.errorUndefined')
            })
        }
    }

    const handleDownload = (documentId) => {
        let isService = false
        props.actions.download_Viatic_Document(props.userLanguage, props.userToken, documentId, isService, onError)
    }

    const handleDelete = (documentId) => {
        handleOpenBackdrop()
        props.actions.delete_Viatic_Document(props.userLanguage, props.userToken, params.instalationId, documentId, onError, onSuccessDelete)
    }

    const invoiceColumns = [
        {
            name: t('telematicsDetail.fileName'),
            selector: 'fileName',
            width: '505px',
            sortable: true,
            cell: row => row.fileName
        },
        {
            name: t('collateralDetails.registerDate'),
            selector: 'createDate',
            width: '505px',
            sortable: true,
            cell: row => row.createDate
        },
        {
            name: "",
            center: true,
            cell: row => (buttonForInvoiceColumns(row))
        },
        {
            center: true,
            omit: true,
            cell: row => row.supplierServiceID
        }
    ]

    const buttonForInvoiceColumns = (row) => {
        return (
            <div>
                <Tooltip title={t('common.download')}>
                    <IconButton style={{ color: '#82C341' }} onClick={() => handleDownload(row.id)}>
                        <GetAppIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title={t('common.delete')}>
                    <IconButton style={{ color: '#BF2E2E' }} onClick={() => handleDelete(row.id)}>
                        <DeleteForeverIcon />
                    </IconButton>
                </Tooltip>
            </div>
        )
    }

    return (
        <Container className={classes.generalBorder}>
            <Backdrop className={classes.backdrop} open={openBackdrop}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <br />
            <Grid container >
                <Grid item xs={5}>
                    <Typography variant="body1" style={{ fontWeight: 600 }}>{t('telematicsDetail.numberOrderInstalation')}</Typography>
                    <Typography variant="body1" >{props.match.params.instalationId}</Typography>
                </Grid>
                <Grid item xs={1}><br /> </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth >
                        <Grid item xs={5}><Typography variant="body1" style={{ fontWeight: 600 }}>{t('telematicsDetail.invoiceDetails')}</Typography></Grid>
                        <Typography variant="body2">{t('collateralDetails.xlsFile')}</Typography>
                        <Input
                            fullWidth
                            type="file"
                            name="excel"
                            onChange={checkFileTypeXLS}
                            className="fileXLS"
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <br />
            <Grid item xs={5}>
                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('telematicsDetail.invoicePerDiem')}</Typography>
            </Grid>
            <Grid container  >
                <Grid item xs={5}>
                    <FormControl fullWidth >
                        <Typography variant="body2">{t('collateralDetails.xmlFile')}</Typography>
                        <Input
                            fullWidth
                            type="file"
                            name="xml"
                            onChange={checkFileTypeXML}
                            className="fileXML"
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={1}><br /> </Grid>
                <Grid item xs={6}>
                    <FormControl fullWidth >
                        <Typography variant="body2">{t('collateralDetails.pdfFile')}</Typography>
                        <Input
                            fullWidth
                            type="file"
                            name="pdf"
                            onChange={checkFileTypePDF}
                            className="filePDF"
                        />
                    </FormControl>
                </Grid>
            </Grid>

            <Grid item xs={12} className={classes.buttonAlign}>
                <br />
                <Button variant="outlined" className={classes.generalBorder} onClick={handleSubmit} > {t('common.upload')} </Button>
            </Grid>

            <Grid item xs={12}><br /></Grid>
            <Divider />
            <Grid item xs={12}><br /></Grid>

            <Grid container >
                <DataTable
                    noHeader
                    columns={invoiceColumns}
                    data={props.listViaticDocuments}
                    defaultSortField="installationOrderId"
                    customStyles={customStyleSecondary}
                    highlightOnHover
                    dense
                    responsive
                    striped
                    pointerOnHover
                    pagination
                    paginationComponentOptions={paginationOptions}
                    subHeader={false}
                    noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
                />
                {
                    props.listViaticDocuments && props.listViaticDocuments.length < 1 && (
                        <Grid container item xs={12}><br /></Grid>
                    )
                }
            </Grid>
        </Container>
    )
}

const mapStateToProps = state => ({
    listViaticDocuments: state.TelematicsReducer.listViaticDocuments,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(TelematicsActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(TelematicsStyles)(ViaticInvoice))